/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_onboarding_account_type_individual_description = /** @type {(inputs: {}) => string} */ () => {
	return `Para uso personal — tarjetas, transferencias y stablecoins.`
};

const en_onboarding_account_type_individual_description = /** @type {(inputs: {}) => string} */ () => {
	return `For personal use — cards, transfers, and stablecoins.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const onboarding_account_type_individual_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.onboarding_account_type_individual_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("onboarding_account_type_individual_description", locale)
	if (locale === "es") return es_onboarding_account_type_individual_description(inputs)
	return en_onboarding_account_type_individual_description(inputs)
};
export { onboarding_account_type_individual_description as "onboarding.account_type.individual_description" }